import React, { useState } from "react"
import { RollbackOutlined } from "@ant-design/icons"

import { hasAccess } from "@components/Authorization"

const LABEL_MOVE = "Transfer"

const useSelectableActions = ({
  table,
  hasTransferOption,
  investmentsTransferModal,
}) => {
  const [ isDisabled, setIsDisabled ] = useState(true);

  const canCreateInvestments = hasAccess(['investments-write'])
  const isTransferAvailable = canCreateInvestments && hasTransferOption

  if (!isTransferAvailable) {
    return []
  }

  const onTransferClick = () => {
    const ids = table.current.getSelectedRowKeys()

    const afterAction = async () => {
      await table.current.indexItems()

      table.current.setSelectedRowKeys([])
      setIsDisabled(true)
    }

    investmentsTransferModal.current.open(ids, afterAction)
  }

  const onSelectionChange = ids => {
    const hasItems = ids.length > 0

    if (!hasItems) {
      setIsDisabled(true)
      return
    }

    setIsDisabled(false)
  }

  const actions = [
    {
      icon: <RollbackOutlined />,
      title: LABEL_MOVE,
      action: onTransferClick,
      disabled: isDisabled,
    },
  ]

  const hasActions = actions.length > 0

  if (!hasActions) {
    return []
  }

  return [ actions, onSelectionChange ]
}

export default useSelectableActions
